'use client';

import { WizardProvider, useWizard } from '../model/wizard-context';
import { StepEmail } from './steps/step-email';
import { StepProfile } from './steps/step-profile';
import { StepPlan } from './steps/step-plan';
import { StepPayment } from './steps/step-payment';
import { StepConfirmation } from './steps/step-confirmation';


const StepSwitch = () => {
    const { state } = useWizard();

    switch (state.step) {
        case 'email':
            return <StepEmail/>;

        case 'profile':
            return <StepProfile/>;

        case 'plan':
            return <StepPlan/>;

        case 'payment':
            return <StepPayment/>;

        case 'confirmation':
            return <StepConfirmation/>;

        default:
            return null;
    }
};


export const RegistrationWizard = () => {
    return (
        <WizardProvider>
            <div data-template="registration-wizard">
                <StepSwitch/>
            </div>
        </WizardProvider>
    );
};
